import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedBox,
  Box,
  ExtendedFlex,
  Heading,
  Body,
  VisibilitySensor,
  Link,
} from '../../../../coreui';

import backgroundImage from '../../../../assets/img_panel_1031.jpg';
import FadeIn from '../../../../components/FadeIn';

const StrategySection1 = ({
  handleSensorChange,
  isVisible,
  isLoggedIn,
}) => {
  return (
    <Box
      width={[1, 1, 0.5, 0.5, 0.5]}
    >
      <ExtendedBox
        w={1}
        bgRepeat="no-repeat"
        bgImage={backgroundImage}
        bgPosition="50% 26%"
        bgSize="cover"
      >
        <Box
          w={1}
          px={['15%', '25%', '10%', '10%', '10%']}
        >
          <ExtendedFlex
            flexDirection="column"
            align={['center', 'center', 'flex-end', 'flex-end', 'flex-end']}
          >
            <ExtendedFlex
              maxWidth={['100%', '100%', 400, 400, 540]}
              flexDirection="column"
              my={[60, 60, 100, 100, 100]}
              mr="auto"
              ml={['auto', 'auto', 100, 140, 180]}
            >
              <FadeIn>
                <Heading
                  type="H2"
                  color="white"
                  m={0}
                  mb="1em"
                  opacity={isVisible ? '1' : '0'}
                >
                  1031 Exchanges made simple
                </Heading>
              </FadeIn>
              <VisibilitySensor
                callback={handleSensorChange}
              />
              <FadeIn
                fadeInIndex={2}
              >
                <Body
                  type="B1"
                  color="white"
                  fontWeight="light"
                  mb={[200, 200, 260, 260, 300]}
                  opacity={isVisible ? '1' : '0'}
                >
                  The RealtyMogul platform can reduce stress and uncertainty in the search to find 1031 eligible investments.
                </Body>
                { !isLoggedIn &&
                <ExtendedBox
                  opacity={isVisible ? '1' : '0'}
                  flexDirection="column"
                >
                  <Link
                    type="L1"
                    to="/1031-exchange"
                  >
                    Learn More
                  </Link>
                </ExtendedBox> }
                {
                  isLoggedIn &&
                  <ExtendedFlex
                    opacity={isVisible ? '1' : '0'}
                    flexDirection="column"
                  >
                    <Link
                      type="L1"
                      to="/investment-opportunities"
                    >
                      View Investments
                    </Link>
                    <Link
                      type="L2"
                      to="/1031-exchange"
                      mt={40}
                    >
                      Learn More
                    </Link>
                  </ExtendedFlex>
                }
              </FadeIn>
            </ExtendedFlex>
          </ExtendedFlex>
        </Box>
      </ExtendedBox>
    </Box>
  );
};

StrategySection1.propTypes = {
  handleSensorChange: PropTypes.func,
  isVisible: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
};

export default StrategySection1;
